module.exports = __webpack_public_path__ + "static/img/user4.bff1caa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user4.jpg
// module id = Df3N
// module chunks = 23